import React, { useEffect, useState } from 'react';
import { Button, Grid, Typography, useMediaQuery } from '@material-ui/core';
import { MembershipCard } from './components/';
import { useSelector, useDispatch } from 'react-redux';
import {
    actionGetMembershipPackages, actionResetCustomer, actionResetMemberValidation, actionGetCustomer, actionResetCustomerUdfs, actionResetCustomerAddresses,
    actionGetMemberMemberships, actionGetCustomerUdfs,
    actionSetErrorMemberValidation, actionUpdatePackageForRenew, actionUpdatePackageForRenewNewMembershipPackage,
    actionGetCustomerAddresses
} from 'actions';
import { makeStyles } from '@material-ui/styles';
import ErrorHandling from '../../components/ErrorHandling/ErrorHandling';
import { actionStartAppLoader, actionEndAppLoader } from '../../actions/actionAppLoader';
import { actionResetPaymentTransaction } from 'actions';
import { genfunction } from 'helpers';

const { MembershipPackagesDisplayAreaNo, PurchaseMembershipNotAllowedForOrganizationBooking, MembershipLandingRenewHeading, MembershipLandingRetrieveButton, SuccessRenewMsg,
    RenewMembershipNotAllowedForNonPrimarMemberMsg, RenewMembershipIfUserHaveNoMembership } = window['runConfig'];


const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            marginTop: theme.spacing(5)
        }
    },
    pagination: {
        marginTop: theme.spacing(3),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },
    btnAlign: {
        marginLeft: '15px',
        marginTop: '-5px',

        [theme.breakpoints.up('sm')]: {
            marginLeft: '15px',
            marginTop: '-5px',
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '15px',
            marginTop: '5px',
        }
    }
}));


const MembershipList = (props) => {
    const classes = useStyles();
    const isSmScreen = useMediaQuery(theme => theme.breakpoints.down('sm'));

    const dispatch = useDispatch();

    //Reducer Objects
    const membershipPackages = useSelector(state => state.reducerShopCart.MembershipPackages);
    const reducerMembershipPackages = useSelector(state => state.reducerMembershipPackages);
    const events = useSelector(state => state.reducerShopCart.events);
    const paymenttranstate = useSelector(state => state.reducerPaymentTransaction.Payment);
    const gaTickets = useSelector(state => state.reducerShopCart.GATickets);
    const giftcards = useSelector(state => state.reducerGiftCards);
    const donationProducts = useSelector(state => state.reducerShopCart.donationProducts);
    const memberValidationReducer = useSelector(state => state.reducerMemberValidation);
    const membermerberships = useSelector(state => state.reducerMemberMemberships);
    const customer = useSelector(state => state.reducerCustomer);

    //Statescustomer
    const [colorState, setColorState] = React.useState('');
    const [error, seterror] = useState("");

    let ismemberValid = false;

    if (memberValidationReducer.membervalidation && memberValidationReducer.membervalidation.MemberValidation
        && memberValidationReducer.membervalidation.MemberValidation[0].hasOwnProperty("EmailMatched")
        && (memberValidationReducer.membervalidation.MemberValidation[0].EmailMatched ||
            memberValidationReducer.membervalidation.MemberValidation[0].PhoneMatched ||
            memberValidationReducer.membervalidation.MemberValidation[0].AddressMatched)) {
        ismemberValid = true;
    }

    const GetCustomersIDList = () => {
        let ids = "";

        ids += customer.customer[0].CustomerID;

        if (customer.customer[0].hasOwnProperty("LinkedIndividuals") && customer.customer[0].LinkedIndividuals.length > 0) {

            customer.customer[0].LinkedIndividuals.forEach(c => {
                ids += "," + c.CustomerID;
            });
        }

        return ids;
    }

    useEffect(() => {

        if (ismemberValid === true) {

            if (memberValidationReducer.membervalidation &&
                memberValidationReducer.membervalidation.MemberValidation &&
                (memberValidationReducer.membervalidation.MemberValidation[0].EmailMatched ||
                    memberValidationReducer.membervalidation.MemberValidation[0].PhoneMatched ||
                    memberValidationReducer.membervalidation.MemberValidation[0].AddressMatched)
                && props.location.emailaddress !== undefined && props.location.emailaddress.trim().length > 0) {

                actionGetCustomer(dispatch, memberValidationReducer.membervalidation.MemberValidation[0].CustomerID, props.location.emailaddress.trim());
            }
        }

    }, [ismemberValid]);

    const GetCustomerLinkIndividualsIDs = () => {
        let Ids = "";

        if (customer.customer[0].LinkedIndividuals && customer.customer[0].LinkedIndividuals.length > 0) {
            customer.customer[0].LinkedIndividuals.map(linkUser => {

                Ids += linkUser.CustomerID + ",";

            });
        }

        return Ids;
    }

    useEffect(() => {

        if (customer.customer && customer.customer.length > 0) {

            if (customer.customer[0].IsFamilyHead === false) {
                seterror(RenewMembershipNotAllowedForNonPrimarMemberMsg);
                actionResetCustomer(dispatch);
                actionResetMemberValidation(dispatch);
                actionResetCustomerUdfs(dispatch);
                actionResetCustomerAddresses(dispatch);
            }
            else {
                //Call Memberships with member ID
                if (membermerberships && membermerberships.membermerberhips) {

                    //Get Customers Addresses
                    let linkUserIDs = GetCustomerLinkIndividualsIDs(customer);
                    if (linkUserIDs !== "" && linkUserIDs.trim().length > 0) {
                        actionGetCustomerAddresses(dispatch, linkUserIDs.replace(/,*$/, ''));
                    }

                    actionGetMemberMemberships(dispatch, customer.customer[0].CustomerID);
                    actionGetCustomerUdfs(dispatch, GetCustomersIDList());
                }
            }
        }

        if (customer.customerError && customer.customerError.length) {
            seterror(customer.customerError);
        }

    }, [customer.customer]);

    useEffect(() => {
        if (events && events.length == 0 && membershipPackages && membershipPackages.length == 0 && gaTickets && gaTickets.length == 0 &&
            giftcards.giftcards && giftcards.giftcards.length == 0 && donationProducts && donationProducts.length == 0 && paymenttranstate.hasOwnProperty("ReceiptNo") && paymenttranstate.ReceiptNo.toString().length > 0) {
            actionResetPaymentTransaction(dispatch);
        }
    }, []);

    useEffect(() => {
        if (reducerMembershipPackages && reducerMembershipPackages.membershippackagesError && reducerMembershipPackages.membershippackagesError.length > 0) {
            seterror(reducerMembershipPackages.membershippackagesError);
        }
    }, [reducerMembershipPackages.membershippackagesError]);

    useEffect(() => {

        if (reducerMembershipPackages.loading == true) {
            actionStartAppLoader(dispatch);
        }
        else {
            actionEndAppLoader(dispatch);
        }

    })

    useEffect(() => {

        if (ismemberValid === false) {
            actionGetMembershipPackages(dispatch, MembershipPackagesDisplayAreaNo);
        }

    }, []);

    const errorcancelhandle = () => {
        seterror('');
    }


    const RenewRedirect = () => {

        if (genfunction.IsOrganization(events)) {
            setColorState('info');
            seterror(PurchaseMembershipNotAllowedForOrganizationBooking);
        }
        else {
            props.history.push({
                pathname: '/memberships/membervalidate'
            })
        }
    }

    const JoinOrRenewMembershipPage = (membership) => {

        if (ismemberValid) {

            if (membermerberships.membermerberhips && membermerberships.membermerberhips.length > 0
                && memberValidationReducer.membervalidation &&
                memberValidationReducer.membervalidation.MemberValidation) {
                if (membermerberships.membermerberhips[0].Memberships && membermerberships.membermerberhips[0].Memberships.length > 0) {

                    if (membermerberships.membermerberhips[0].CustomerID !== customer.customer[0].CustomerID) {
                        actionSetErrorMemberValidation(dispatch, RenewMembershipNotAllowedForNonPrimarMemberMsg);
                    }
                    else {

                        if (membermerberships.membermerberhips[0].Memberships.filter(x => x.MembershipPackageID === membership.MembershipPackageID && x.IsRenewed === false).length > 0) {

                            actionUpdatePackageForRenew(dispatch, + membership.MembershipPackageID, membermerberships, customer.customer);
                            props.history.push({
                                pathname: '/memberships/renew/' + membership.MembershipPackageID
                            });

                        }
                        else {
                            actionUpdatePackageForRenewNewMembershipPackage(dispatch, + membership.MembershipPackageID, membermerberships, customer.customer);
                            props.history.push({
                                pathname: '/memberships/renew/' + membership.MembershipPackageID
                            });
                        }

                    }
                }

                if (!membermerberships.membermerberhips[0].hasOwnProperty('Memberships')) {
                    actionSetErrorMemberValidation(dispatch, RenewMembershipIfUserHaveNoMembership);
                }
            }

        }
        else {
            if (membershipPackages && membershipPackages.length > 0 && membershipPackages.filter(x => x.MembershipPackageID == membership.MembershipPackageID).length == 0) {
                seterror('You already have one membership package in your cart!');
            }
            else if (genfunction.IsOrganization(events)) {
                setColorState('info');
                seterror(PurchaseMembershipNotAllowedForOrganizationBooking);
            }
            else {
                props.history.push({
                    pathname: '/memberships/join/' + membership.MembershipPackageID
                })
            }
        }
    }

    const GetMemberActiveMembership = () => {
        let membershipPackageID = 0;

        if (ismemberValid) {

            if (memberValidationReducer.membervalidation.MemberValidation && memberValidationReducer.membervalidation.MemberValidation[0].MembershipPackageID) {
                membershipPackageID = memberValidationReducer.membervalidation.MemberValidation[0].MembershipPackageID;
            }
        }

        return membershipPackageID;
    }
    return (

        <div className={classes.root}>
            <Grid container
                spacing={2} >
                <ErrorHandling color={colorState} msg={error.length > 0 ? error : ''}
                    open={error.length > 0 ? true : false} handleclose={errorcancelhandle} />
                {!ismemberValid ? <Grid
                    item
                    xs={12}
                    align={isSmScreen ? 'center' : 'left'}
                >
                    <Typography variant='subtitle1' style={{ display: 'inline' }} color="textSecondary">{MembershipLandingRenewHeading}</Typography>
                    <Button className={classes.btnAlign} variant="contained" color="primary" size="medium" onClick={() => RenewRedirect()}>{MembershipLandingRetrieveButton}</Button>
                </Grid> :
                    <Grid
                        item
                        xs={12}
                        align='center'
                    >
                        <Typography variant="h3" component="h3" color="primary" >{(customer.customer && customer.customer.length > 0 ? customer.customer[0].CustomerName + '! ' : '') + SuccessRenewMsg}</Typography>
                    </Grid>
                }

                {reducerMembershipPackages.membershippackages.map((membership, i) => {
                    return membership !== undefined ?
                        <Grid
                            item
                            key={membership.MembershipPackageID}
                            lg={4}
                            md={6}
                            xs={12}
                        >
                            <MembershipCard membership={membership} JoinOrRenewMembershipPage={JoinOrRenewMembershipPage} activePackageID={GetMemberActiveMembership()} />
                        </Grid>

                        : null
                })}
            </Grid>
        </div >
    );
};

export default MembershipList;
